import React, { useState } from "react";
import Video from "../../videos/herramientas.mp4";
import Logo from "../../images/cpjLogoCompleto.png"
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  HeroH1,
  HeroH2,
  HeroP,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight,
  MedianetLogo
} from "./HeroElements";
import { Button } from "../Button/ButtonElements";
const HeroSection = () => {
  const [hover, setHover] = useState(false);

  const onHover = () => {
    setHover(!hover);
  };

  return (
    <HeroContainer>
      <HeroBg>
        <VideoBg autoPlay loop muted src={Video} type="/video/mp4" />
      </HeroBg>
      <HeroContent>
        <MedianetLogo src={Logo}></MedianetLogo>
        <HeroH1>Alquile la herramienta correcta,</HeroH1>
        <HeroH2> construya su sueño</HeroH2>   
        <HeroBtnWrapper>
          <Button
          
            to="Categorias"
            smooth={true}
            duration={1200}
            onMouseEnter={onHover}
            onMouseLeave={onHover}
            primary="true"
            dark="true "
  
          >
            Mira nuestras herramientas {hover ? <ArrowForward /> : <ArrowRight />}
          </Button>
        </HeroBtnWrapper>            
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection;